import React from "react"

function Minnesota() {
    return (
        <svg version="1.1" xmlns="http://www.w3.org/2000/svg" width="64" height="80" viewBox="0 0 64 80">
            <path d="M18.24 4.48l-0.24-1.44-14-0.48 0.8 4-0.4 1.28v4.32l1.76 5.92-0.16 6.72 0.4 0.8-0.24 3.12 1.44 5.44-0.32 3.44-2.24 2.64 1.12 1.76 1.12 0.56 0.64 0.96-0.8 20 20.8 0.48 21.040-0.080-0.48-4.4-0.8-1.28-2.16-0.64-3.52-3.92-1.6-0.4-0.72-1.12-1.52-0.4-1.84-1.76 0.48-1.76-0.4-1.52 0.4-0.72v-1.52l0.64-1.68-0.64-1.52-1.040-0.080-0.24-1.36 1.68-2.32 3.12-2.080v-6.4h0.48l0.96-1.6 4.4-3.52 4.96-5.6 9.12-4.48-1.68-0.24-0.96 0.32-1.6-1.28-4.48 0.64-1.040-1.68-2.8 2h-2.4l-0.8-0.4-0.32-0.96-1.84-0.56-0.64-1.2-1.52 0.24-0.16 0.88-0.48 0.24-0.96-2.32-1.52-0.16 0.4-0.88-2.24-0.8-2.16-0.24-1.44 0.4-0.4 0.64-1.92 0.080-0.88-1.2-5.36-1.12-0.72-0.64v-0.96h-0.96l-1.040-1.2zM19.6-0.8v2.24l0.96-0.48 0.32-1.040-0.16-0.64z"></path>
        </svg>
    )
}

export default Minnesota